/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {genericPushMessages} from '../api'

export const useMutationGenericPushMessages = createReactQueryMutationHook('genericPushMessages', genericPushMessages)
